import { render } from "./ActionDropdown.vue?vue&type=template&id=08897d6f&scoped=true"
import script from "./ActionDropdown.vue?vue&type=script&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&lang=js"

import "./ActionDropdown.vue?vue&type=style&index=0&id=08897d6f&scoped=true&lang=css"
import "./ActionDropdown.vue?vue&type=style&index=1&id=08897d6f&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08897d6f"]])

export default __exports__